import React from "react";
import {usePipeline} from "@morningtrain/react-helpers";
import useOnConstrain from "../hooks/use-on-constrain";

export default function TriggerPipelineOnConstrain() {

    const pipeline = usePipeline();

    useOnConstrain((constraints) => {

        const payload = {
            constraints
        };

        pipeline.trigger(payload)
            .catch((err) => console.log('caught error', err));
    });

    return null;
}
